import $ from 'cash-dom';

const ZeroResultsHandler = {
	init() {
		const $filtersZeroResultsHolder = $('.filters-zero-results-holder');

		if (!$filtersZeroResultsHolder.length) {
			return;
		}

		$(document).on('filters-change', function (e, {vendorOrderData}) {
			if (Object.keys(vendorOrderData).length) {
				$filtersZeroResultsHolder.addClass('hidden');
			} else {
				$filtersZeroResultsHolder.removeClass('hidden');
			}
		});
	}
};

export default ZeroResultsHandler;
